export const WELCOME_EMAIL_TOKENS = [
  {
    token: '[navn]',
    description: 'fornavn',
  },
  {
    token: '[program]',
    description: 'sirkelens tittel',
  },
  {
    token: '[innlogging]',
    description: 'innloggingslenke til Dunbar',
  },
] as const;

export type WelcomeEmailToken = (typeof WELCOME_EMAIL_TOKENS)[number]['token'];

const TOKEN_SET = new Set<string>(
  WELCOME_EMAIL_TOKENS.map((item) => item.token)
);

export const DEFAULT_WELCOME_EMAIL_SUBJECT =
  'Velkommen som deltaker hos Ordtilhandling';

export const DEFAULT_WELCOME_EMAIL_BODY = `Hei [navn],

Velkommen som deltaker på [program] hos Ordtilhandling! Vi er veldig glade for å ha deg med, og ser frem til en lærerik og inspirerende tid sammen.

For å sikre at du får mest mulig ut av programmet, har vi samlet all relevant informasjon og alt materiell på vår digitale plattform Dunbar. Vi anbefaler at du laster ned appen og logger inn så snart som mulig, slik at du er klar til oppstart.

I Dunbar vil du til enhver tid finne:
- Praktisk informasjon og agenda for kommende samlinger
- Presentasjoner og faglig materiell etter hver samling
- Hjemmelekser og refleksjonsoppgaver mellom samlingene
- Viktige beskjeder og oppdateringer fra OTH-teamet

Logg inn her: [innlogging]

Vennlig hilsen
Carla Linnea Stadsnes Broschè`;

const BRACKET_TOKEN_PATTERN = /\[[^\]]+\]/g;

export const findUnknownWelcomeEmailTokens = (text: string): string[] => {
  const matches: string[] = text.match(BRACKET_TOKEN_PATTERN) ?? [];
  return matches.filter(
    (token, index) => !TOKEN_SET.has(token) && matches.indexOf(token) === index
  );
};

export type WelcomeEmailPreviewValues = {
  navn: string;
  program: string;
  innlogging: string;
};

export const previewWelcomeEmail = (
  text: string,
  values: WelcomeEmailPreviewValues
): string =>
  text
    .replaceAll('[navn]', values.navn)
    .replaceAll('[program]', values.program)
    .replaceAll('[innlogging]', values.innlogging);
